export default function Bulk() {
    return <><h1>Hello Adam!</h1></>
}